import React, { useMemo } from 'react';
import { PolicyOverdueDebtDetail, PolicyOverdueDebtHeaders } from '../../../../../shared/interfaces/services/policy-overdue-debt-service';
import { CardRender } from '../../../../../shared/components/CardRender';
import { renderCurrency } from '../../../../../shared/utils';
import dayjs from 'dayjs';

interface PolicyOverdueDebtCardProps {
    policy: PolicyOverdueDebtDetail;
    headers: PolicyOverdueDebtHeaders;
    loading?: boolean;
    key: string;
}



const PolicyOverdueDebtCard: React.FC<PolicyOverdueDebtCardProps> = ({ policy, loading, headers }) => {
    const {
        rama,
        poliza,
        suplemento,
        asegurado,
        formaDePago,
        moneda,
        impagoDesde,
        deudaMasDe90Dias,
        deudaHasta90Dias,
        deudaHasta60Dias,
        deudaHasta30Dias,
        deudaPorVencer
    } = policy;
    
    const columnsDataDebt = useMemo(() => [
        {
            label: 'Rama',
            value:  rama,
            isLikeTitle: true,
            valueInBold: true,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Póliza',
            value: poliza,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Suplemento',
            value: suplemento,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Asegurado',
            value: asegurado,
            valueInBold: true,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Forma de Pago',
            value: formaDePago,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Moneda',
            value: moneda,
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Impago Desde',
            value: dayjs(impagoDesde).format('DD/MM/YYYY'),
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: `Deuda anterior`,
            value: renderCurrency(deudaMasDe90Dias),
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: `Hasta ${headers.firstColumn}`,
            value: renderCurrency(deudaHasta90Dias),
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: `Hasta ${headers.secondColumn}`,
            value: renderCurrency(deudaHasta60Dias),
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: `Hasta ${headers.thirdColumn}`,
            value: renderCurrency(deudaHasta30Dias),
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
        {
            label: 'Deuda por Vencer',
            value: renderCurrency(deudaPorVencer),
            columnSize: { xs: { span: 12 }, sm: { span: 6 } },
        },
    ], [
        rama,
        poliza,
        suplemento,
        asegurado,
        formaDePago,
        moneda,
        impagoDesde,
        deudaMasDe90Dias,
        deudaHasta90Dias,
        deudaHasta60Dias,
        deudaHasta30Dias,
        deudaPorVencer,
        headers
    ]);
    

    return (
        <CardRender
            title={''}
            article={undefined}
            tags={undefined}
            actions={undefined}
            loading={loading}
            columnsData={columnsDataDebt}
        />
    );
};

export default PolicyOverdueDebtCard;